import axios from "axios";

export function getDepartmentByCompany(companyId) {
  return axios.get(`api/department/${companyId}`);
}
